// config.js
const config = {
    // baseUrl: "https://vps-5a69ed13.vps.ovh.net:8003",
    // apiBaseUrl: "https://vps-5a69ed13.vps.ovh.net:8003/api/",

    // baseUrl: "http://localhost:3001",
    // apiBaseUrl: "http://localhost:3001/api/",

    baseUrl: "",
    apiBaseUrl: "/api/",

    // baseUrl: "https://squad.dev.cayenne-systems.com",
    // apiBaseUrl: "https://squad.dev.cayenne-systems.com/api/",

    // baseUrl: "https://system.antico.ps",
    // apiBaseUrl: "https://system.antico.ps/api/",

    maxResults: 20,
    userString: "User",
    userStringFields:
        'fields=["name", "user_type"]&order_by=modified DESC&limit=1000',
    salesInvoiceString: "Sales Invoice",
    salesInvoiceFields:
        'fields=["name", "title", "status", "moditemsified", "grand_total", "currency"]&order_by=modified DESC&limit=1000',
    items: "Item",
    itemFields:
        'fields=["name","description", "modified", "disabled" , "stock_uom" , "allow_alternative_item",' +
        '"is_stock_item", "opening_stock", "is_fixed_asset" , "image", "brand"]&order_by=modified DESC&limit=1000',
    employee: "Employee",
    employeeFields:
        'fields=["first_name","last_name", "middle_name", "employee_name" , "gender" , "date_of_birth",' +
        '"salutation", "company", "department" , "employment_type"]&order_by=modified DESC&limit=1000',
    posProfile: "POS Profile",
    posProfileFields:
        'fields=["company", "customer", "country", "disabled", "warehouse", "campaign",' +
        '"posa_cash_mode_of_payment", "posa_use_percentage_discount","posa_max_discount_allowed", ' +
        '"posa_allow_partial_payment", "posa_allow_credit_sale",' +
        '"posa_allow_return", "posa_apply_customer_discount"]&order_by=modified DESC&limit=1000',

    // POST methods.
    userPermissionsUrl:
        "frappe.core.doctype.user_permission.user_permission.get_user_permissions",
    tagsListForAwesomeBarUrl:
        "frappe.desk.doctype.tag.tag.get_tags_list_for_awesomebar",
    notificationLogUrl:
        "frappe.desk.doctype.notification_log.notification_log.get_notification_logs",
    eventsMethodUrl: "frappe.desk.doctype.event.event.get_events",
    deskPageMethodUrl: "frappe.desk.desk_page.getpage",
    searchLinkUrl: "frappe.desk.search.search_link",
    getListUrl: "frappe.client.get_list",
    getAllList: "frappe.get_all",
    resturant_manage_get_settings:
        "restaurant_management.restaurant_management.page.restaurant_manage.restaurant_manage.get_settings_data",
    resturant_manage_get_rooms:
        "restaurant_management.restaurant_management.page.restaurant_manage.restaurant_manage.get_rooms",
    GET_ROOMS: {
        URL: "restaurant_management.restaurant_management.page.restaurant_manage.restaurant_manage.get_rooms",
    },

    resturant_manage_get_items:
        "restaurant_management.restaurant_management.page.restaurant_manage.restaurant_manage.get_items",
    // resturant_manage_count_rooms: 'restaurant_management.restaurant_management.page.restaurant_manage.restaurant_manage.get_item_group_condition',
    resturant_manage_count_rooms: "frappe.core.doctype.user.user.get_all_roles",

    resturant_manage_create_room: "frappe_helper.api.call",
    resturant_manage_add_room:
        "restaurant_management.restaurant_management.page.restaurant_manage.restaurant_manage.add_room",
    resturant_manage_add_table: "frappe_helper.api.call",
    // method.
    resturant_manage_check_selling:
        "erpnext.selling.page.point_of_sale.point_of_sale.check_opening_entry",
    resturant_manage_check_stock:
        "frappe.client.get_value?doctype=Stock%20Settings&fieldname=allow_negative_stock&_=1683733552009",
    resturant_manage_check_pos_profile:
        "frappe.client.get?doctype=POS Profile&name=Antico POS&_=1683733552010",

    resturant_manage_pos_opening:
        "erpnext.selling.page.point_of_sale.point_of_sale.check_opening_entry",
    resturant_manage_pos_items:
        "erpnext.selling.page.point_of_sale.point_of_sale.get_items",

    resturant_customer_accept:
        "frappe_helper.frappe_helper.doctype.desk_form.desk_form.accept",
    resturant_call_desk:
        "frappe_helper.frappe_helper.doctype.desk_form.desk_form.accept",
    request_fetch_invoice:
        "frappe_helper.frappe_helper.doctype.desk_form.desk_form.get_form_data",

    // takeaway_table_identity:'6bbf725a8d',
    request_doctype_validate_method: "frappe.client.validate_link",
    takeaway_table_identity: "5930e869bf",
};

export default config;
